module.exports = __webpack_public_path__ + "media/images/best_concept-s@2x-c1ab4e7e2dee8f56e6a7118778fb0764.png";